export default __webpack_public_path__ + "static/media/pic4.053798fb.jpg";